module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am183-ff4c88e2160926e4680fdbbc3688c64a.jpg";